export const opacity = {
  SemiOpaque: "0.72",
  Intense: "0.64",
  Medium: "0.32",
  Light: "0.16",
  SemiTransparent: "0.08",
} as const;
